import { HelpersService } from 'src/app/services/helpers.service';
import { MentoriaService } from './../../../services/mentoria.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-criar-questao',
  templateUrl: './criar-questao.component.html',
  styleUrls: ['./criar-questao.component.css']
})
export class CriarQuestaoComponent implements OnInit {

  hackathonId = this.helper.hackathonId;
  userID = '';
  userDisplayName = '';
  topico = '';
  duvida = '';

  constructor(public mentoria: MentoriaService,
              private helper: HelpersService,
              private auth: AuthService) { }

  ngOnInit() {
    this.auth.getUser.then(user => {
      this.userID = user.user.uid;
      this.userDisplayName = user.user.displayName;
    });
  }

  criarQuestao() {

    if (this.topico.length <= 0) {
      this.helper.openSnackBar('O titulo do tópico não deve ser vázio!','Entendido!');
      return;
    }

    if (this.duvida.length <= 0) {
      this.helper.openSnackBar('A sua duvida deve ser preenchida!','Entendido!');
      return;
    }

    this.mentoria.criarQuestaoTopicoNoforum(
      this.userID,
      this.userDisplayName,
      this.topico,
      this.duvida,
      this.hackathonId
    );
    this.topico = '';
    this.duvida = '';
    this.helper.routeToMentoria();
  }

}
